import {XL_WIDTH} from "@main/helpers/const";

class WillStudyList {
    constructor(el) {
        this.el = el;
        this.resizeObserver = new ResizeObserver(this.onDocumentResize, 200);
        this.resizeObserver.observe(document.body);
    }

    onDocumentResize = ([entry]) => {
        if (entry.contentRect.width > XL_WIDTH) {
            this.el.style.gridTemplateRows = `repeat(${Math.ceil(this.el.childElementCount / 2)}, auto)`;
            this.el.style.gridAutoFlow = "column";
        } else {
            this.el.style.gridTemplateRows = null;
            this.el.style.gridAutoFlow = null;
        }
    };
}

document.querySelectorAll(".js-will-study-list").forEach((el) => new WillStudyList(el));
